import { TabIds } from '@containers/ProductDetailContainer/ProductDetail/model';

import { useTabSwitcher } from './context/TabSwitcherContext';

export const useTabLink = (tabId: number, isDefaultTab?: boolean) => {
  const { activeTabId, setActiveTab, toggleIsReviewTabVisibleOnMobile } =
    useTabSwitcher();
  const setActiveTabHandler = () => {
    setActiveTab(tabId);

    if (tabId === TabIds.Reviews) {
      toggleIsReviewTabVisibleOnMobile();
    }
  };

  const isActive: boolean =
    (typeof activeTabId === 'undefined' && isDefaultTab) ||
    activeTabId === tabId;

  return { isActive, setActiveTabHandler };
};
